import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Input from '../../elements/Input';
import { getDataAsJSON } from '../../../helpers/dataHelper';
import postQuoteRequest from '../../../services/StoreService';
import PageErrorMessage from '../../PageErrorMessage';
import * as analytics from '../../../services/analytics';
import {PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL} from "../../../constants/url";

const SendMessage = props => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { register, control, handleSubmit, setValue } = useForm({
        shouldUseNativeValidation: true,
        mode: 'onBlur',
    });
    const [errorMessage, setErrorMessage] = useState('');

    const maxWidthInputs = state.adviceArea === 392 ? '280px' : 'auto';

    const handleClick = event => {
        event.target.classList.add('touched-input');
    };

    const onSubmit = async data => {
        let params = {
            adviceArea: state.adviceArea,
            message: state.message,
            fullName: state.formData.fullName,
            email: state.formData.email,
            phone: data.phone,
            postcode: state.formData.postcode,
            wealthLevel: state.formData.wealthLevel,
            deposit: state.formData.deposit,
            mortgageValue: state.formData.mortgageValue,
            annualIncome: state.formData.annualIncome,
            adviceTime: state.formData.adviceTime,
            utm: state.utm,
            isLocationImportant: state.formData.isLocationImportant
        };
        let dataAsJson = getDataAsJSON(params);

        postQuoteRequest(dataAsJson)
            .then(() => {
                navigate('/finish');
            })
            .catch(error => {
                setErrorMessage(
                    'An error occurred while sending your data. Please try again in a few seconds.'
                );
            });

        analytics.track('Clicked Send Message', {
            category: 'Message page',
        });
    };

    const goBack = () => {
        navigate('/match', { state });
    };

    const renderButtons = () => {
        return (
            <section className="app__main-section app__main-section__actions--alignment">
                <div className="app__main-section__actions">
                    <button
                        className="big-button back vouchedfor-brand"
                        onClick={goBack}
                        type="button">
                        Previous
                    </button>
                    <button type="submit" className="big-button vouchedfor-brand">
                        Send
                    </button>
                </div>
                <div className="contact-link push-down-50 push-up-30">
                    Not ready to contact anyone yet? Give us a call on{' '}
                    <a href="tel:02031110583">0203 111 0583</a>
                    <div>All enquiries are subject to our&nbsp;
                        <a
                            href={TERMS_AND_CONDITIONS_URL}
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                        >
                        Terms and Conditions
                        </a>
                        &nbsp;and&nbsp;
                        <a
                            href={PRIVACY_POLICY_URL}
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                        >
                        Privacy Policy
                        </a>
                    </div>
                </div>
            </section>
        );
    };

    const handlePhoneChange = event => {
        state.formData.phone = event.target.value;
    };

    const handleMessageChange = event => {
        state.message = event.target.value;
    };

    useEffect(() => {
        if (state.formData) {
            setValue('message', state.message);
            setValue('phone', state.formData.phone);
        }
    }, []);

    return (
        <div>
            {errorMessage && <PageErrorMessage errorMessage={errorMessage}></PageErrorMessage>}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="app__editable-input">
                    <textarea
                        className="app__text-area"
                        rows="5"
                        defaultValue={state.message}
                        register={{ ...register('message') }}
                        required
                        onBlur={handleMessageChange}
                    />
                </div>
                <Input
                    name="phone"
                    label="The best number to contact me on is:"
                    placeholder="01234 567 890"
                    widthProportion="fixed"
                    isPhone={true}
                    fixedWidth={maxWidthInputs}
                    onClick={handleClick}
                    hintText="Most advisers will call you to discuss your request"
                    required
                    control={{ ...control }}
                    register={{
                        ...register('phone', {
                            required: 'Please enter your phone number.',
                            maxLength: 13,
                        }),
                    }}
                    onBlur={handlePhoneChange}
                />
                {renderButtons()}
            </form>
        </div>
    );
};

export default SendMessage;
